import React, { createContext, type ReactNode, useContext, useMemo } from 'react';

type SearchModalControls = {
	openSearch: () => void;
	closeSearch: () => void;
};

const SearchModalContext = createContext<SearchModalControls | undefined>(undefined);

/**
 * Provides search modal controls to descendant components.
 */
export const SearchModalProvider = ({
	children,
	onOpen,
	onClose,
}: {
	children: ReactNode;
	onOpen: () => void;
	onClose: () => void;
}): React.JSX.Element => {
	const value = useMemo(() => ({ openSearch: onOpen, closeSearch: onClose }), [onOpen, onClose]);
	return <SearchModalContext.Provider value={value}>{children}</SearchModalContext.Provider>;
};

export const useSearchModal = (): SearchModalControls => {
	const context = useContext(SearchModalContext);

	if (!context) {
		throw new Error('useSearchModal must be used within a SearchModalProvider');
	}

	return context;
};
